import React from 'react';
import { useTranslation } from 'react-i18next';

import { Panel } from 'components/containers';
import OptionallyVisible from 'components/optionallyVisible';

import RoutePath from 'router/path';

import { formatDateLocal } from 'utils/date';

import { KEYS, LABELS } from '../../keys';
import { OrderPwcSectionProps } from '../../types';
import { Item, ItemName, ItemValue, Link, SectionWrapper } from '../styles';

export const PayoutSection = ({ orderData, rowId }: OrderPwcSectionProps) => {
  const { t } = useTranslation();

  const payout = orderData?.charges.find((charge) => charge.uuid === rowId)?.payout;

  return (
    <Panel label={t(LABELS.SECTIONS.PAYOUT.TITLE)}>
      <OptionallyVisible visible={Boolean(payout?.uuid)}>
        <SectionWrapper>
          <Item>
            <ItemName>{t(LABELS.SECTIONS.PAYOUT.PAYOUT_ID)}</ItemName>
            <OptionallyVisible visible={Boolean(payout?.uuid)}>
              <ItemValue>
                <Link to={RoutePath.pwc.payoutById(orderData.merchant.uuid, payout?.uuid || KEYS.DASH)}>{payout?.uuid}</Link>
              </ItemValue>
            </OptionallyVisible>
          </Item>

          <Item>
            <ItemName>{t(LABELS.SECTIONS.PAYOUT.PAYOUT_DATE)}</ItemName>
            <ItemValue>{formatDateLocal(payout?.submittedAt) ?? KEYS.DASH}</ItemValue>
          </Item>
        </SectionWrapper>
      </OptionallyVisible>
    </Panel>
  );
};
